import React, { useEffect, useState } from "react";
import { getUserRoles, deleteUserRole } from "api";
import errorToast from "helpers/errorToast";
import Dropdown from "components/atoms/Dropdown/Dropdown";
import LoadingSkeleton from "components/atoms/LoadingSkeleton/LoadingSkeleton";
import Button from "components/atoms/Button/Button";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

function DeleteUserRole({ id, count, setShowDelete, closeEditRoleDialog, refetch }) {
  const [data, setData] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [currentRole, setCurrentRole] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getUserRoles({
      params: {
        page_size: count,
      },
    })
      .then((response) => {
        const formattedData = response.data.results
          .map((item) => ({
            label: item.name,
            value: item.id,
          }))
          .filter((item) => item.value !== id);
        setCurrentRole(response.data.results.filter((item) => item.id === id)[0].name);
        setData(formattedData);
        setSelectedRole(formattedData[0]?.value);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        errorToast(error);
      });
  }, []);

  const handleDeleteRole = () => {
    setIsDeleting(true);
    deleteUserRole(id, {
      data: {
        replace_existing_user_role_id: selectedRole,
      },
    })
      .then(() => {
        setShowDelete(false);
        closeEditRoleDialog();
        toast.success("Role deleted successfully");
        refetch(true);
      })
      .catch((error) => errorToast(error))
      .finally(() => setIsDeleting(false));
  };

  if (isLoading) return <LoadingSkeleton rows={2} />;

  return (
    <div>
      <div>
        <FormattedMessage
          id="settings.user-role.deleteUserConfirm"
          defaultMessage={`Are you sure you want to delete role '${currentRole}' from the account?`}
          values={{ currentRole }}
        />
      </div>
      <div className="text-secondary mt-3 mb-2">
        <FormattedMessage
          id="settings.user-role.deleteUserSelect"
          defaultMessage={`Please select a role that the existing '${currentRole}' users will be assigned to:`}
          values={{ currentRole }}
        />
      </div>
      <Dropdown
        options={data}
        defaultValue={data[0]?.label}
        onChange={(e) => setSelectedRole(e.value)}
        placeholder="Select Role"
        className="w-100 mt-3"
      />
      <div className="d-flex justify-content-between mt-3">
        <Button onClick={() => setShowDelete(false)}>Back</Button>
        <Button variant="danger" isLoading={isDeleting} onClick={handleDeleteRole}>
          Delete
        </Button>
      </div>
    </div>
  );
}

DeleteUserRole.propTypes = {
  id: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  setShowDelete: PropTypes.func.isRequired,
  closeEditRoleDialog: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
};

export default DeleteUserRole;
